import { menu } from "@/Data";
import { useCallback, useEffect, useState } from "react";
export function useScrool(pageSLE: string, panelSLE: string) {
    const [mont, setMont] = useState(false);
    useEffect(() => { setMont(true); setTimeout(() => window.scrollTo(0, 0), 1); }, []);
    useEffect(() => { if (mont) setTimeout(() => window.scrollTo(0, 0), 1) }, [pageSLE, mont]);
    const chance = useCallback(() => {
        if (mont && panelSLE !== undefined) { moveId(panelSLE); }
        else setTimeout(() => chance(), 10)
    }, [panelSLE, mont]);
    return chance;
}
function moveId(id: string) {
    setTimeout(() => {
        const div = document.getElementById(id);
        if (div !== null) {
            const { top } = div.getBoundingClientRect();
            const par = (top - menu.height) / 40;
            scrollTo(par);
        }
    }, 10)
}
function scrollTo(par: number, i = 0) {
    if (i < 40) setTimeout(() => {
        window.scrollTo(0, window.scrollY + par)
        scrollTo(par, i + 1)
    }, i);
}